import { Box, styled } from '@mui/material';
import { useCallback } from 'react';

import { ResourceRegionType } from '../../../shared';
import { useGeoMap } from '../../GeoMap';
import { DeviceSpecialistGroupCard } from '../../HubStatusCard';
import { hubAnchors } from '../lib';

import type { HubReportStatus } from '#entities';

interface Props {
  hubs: HubReportStatus[];
  onClickHub: (id: string) => void;
}

const Root = styled(Box)({
  position: 'absolute',
  inset: 0,
  pointerEvents: 'none',
});

const Floating = styled(Box)({
  position: 'absolute',
  transform: 'translate(-50%, -100%)',
  pointerEvents: 'auto',
});

export const HubsAtCoordinates = ({ hubs, onClickHub }: Props) => {
  const { projectionRef } = useGeoMap();

  const project = useCallback(
    (lonLat: [number, number]) => {
      const p = projectionRef.current;
      return p(lonLat) || [NaN, NaN];
    },
    [projectionRef],
  );

  const nodes = hubs
    .map(h => {
      const key = String(h.id);
      const anchor = hubAnchors[key];
      if (!anchor) {
        return null;
      }

      const [x, y] = project(anchor.lonLat);
      if (!Number.isFinite(x) || !Number.isFinite(y)) {
        return null;
      }

      const style = {
        left: `${Math.round(x)}px`,
        top: `${Math.round(y)}px`,
      };

      const isEastOverride = anchor.alignment === 'left';

      return (
        <Floating key={key} style={style}>
          <DeviceSpecialistGroupCard
            region={ResourceRegionType.East}
            {...h}
            isEastOverride={isEastOverride}
            onClick={() => onClickHub(h.id)}
          />
        </Floating>
      );
    })
    .filter(Boolean);

  return <Root>{nodes}</Root>;
};
